module.exports = __webpack_public_path__ + "static/media/GiveMeASign_Bookcover.10fa6112.jpg";